import { useMemo } from 'react'
import { emptyTreatmentField, TreatmentFormFields } from '../types/types'

export const useTreatmentInitialState = (
	isEdit: boolean,
	editData?: Partial<TreatmentFormFields>,
): TreatmentFormFields[] => {
	return useMemo(() => {
		if (isEdit && editData) {
			return [
				{
					title: editData.title || '',
					description: editData.description || '',
					duration: editData.duration ?? '',
					selectedDiagnose: editData.selectedDiagnose || [],
					examinationInterval: editData.examinationInterval ?? '',
					rejectMilk: Boolean(editData.rejectMilk),
					milkRejectDays: editData.milkRejectDays ?? '',
				},
			]
		}

		return [emptyTreatmentField()]
	}, [isEdit, editData])
}
